import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { SigninComponent } from './signin/signin.component';
import { RouterModule, Routes } from '@angular/router';
import { LogoutComponent } from './logout/logout.component';
import { ForgotComponent } from './forgot/forgot.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

// const sectionRoutes: Routes = [
//     { path: '', component: SigninComponent, pathMatch: 'full' },
//     { path: 'signin', component: SigninComponent },
//     { path: 'logout', component: LogoutComponent},
//     { path: 'password-reset', component: ForgotComponent},
//     { path: 'password-change', component: PasswordChangeComponent},
//     { path: '**', redirectTo: 'signin' },
// ];

const sectionRoutes: Routes = [
    { path: '', component: SigninComponent, pathMatch: 'full' },
    { path: 'signin', component: SigninComponent },
    { path: 'logout', component: LogoutComponent},
    { path: 'password-reset', component: ForgotComponent},
    { path: 'password-change', component: PasswordChangeComponent},
    { path: '**', redirectTo: 'signin' },
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(sectionRoutes),
    MatPasswordStrengthModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  declarations: [SigninComponent, LogoutComponent, ForgotComponent, PasswordChangeComponent],
  exports: [RouterModule],
})
export class AuthModule { }
